// Locatiepagina's voor lokale SEO (Hub & Spoke model).
// Elke plaats heeft UNIEKE tekst om duplicate content te voorkomen.

export const locations = [
  {
    slug: "rosmalen",
    name: "Rosmalen",
    title: "Glazenwasser Rosmalen",
    region: "Noord-Brabant",
    postcode: "5240 – 5247",
    lat: "51.7167",
    lng: "5.3667",
    intro:
      "Cleven Cleaning is dé vaste glazenwasser van Rosmalen. Vanuit ons eigen dorp wassen wij dagelijks de ramen van particulieren, VvE's en bedrijven — van de nieuwbouw in De Groote Wielen tot de jaren-30 woningen rond de Molenhoek. Omdat wij hier zelf wonen en werken, kennen we de buurten, de woningtypes en de wensen van onze klanten als geen ander.",
    body:
      "Of het nu gaat om periodieke glasbewassing, het reinigen van uw kozijnen en zonnepanelen of het leeghalen van de dakgoten: u krijgt altijd een vaste glazenwasser die u minimaal 24 uur van tevoren via ons CRM-systeem op de hoogte brengt. Geen verrassingen, geen onbekenden over de poort — wel kristalheldere ramen en een verzorgde uitstraling.",
    neighborhoods: [
      "De Groote Wielen",
      "Sparrenburg",
      "Molenhoek",
      "Hondsberg",
      "Maliskamp",
      "Kruisstraat",
    ],
    nearby: ["den-bosch", "nuland", "berlicum"],
  },
  {
    slug: "den-bosch",
    name: "'s-Hertogenbosch",
    title: "Glazenwasser Den Bosch",
    region: "Noord-Brabant",
    postcode: "5211 – 5237",
    lat: "51.6978",
    lng: "5.3037",
    intro:
      "Op zoek naar een betrouwbare glazenwasser in Den Bosch? Cleven Cleaning is actief in heel 's-Hertogenbosch — van de monumentale panden in de historische binnenstad tot de ruime woningen in Maaspoort, Empel en De Vliert. Wij verzorgen zowel particuliere woningen als winkels, kantoren en VvE-complexen.",
    body:
      "Binnenstadpanden met hoge ramen of moeilijk bereikbare gevels vragen om vakmanschap. Met onze wateronthardingsinstallatie en telescoopstelen tot 12 meter wassen wij streeploos en zonder ladders. Voor grotere bedrijfspanden huren wij desgewenst een hoogwerker in. Heldere planning, vaste medewerkers en een factuur die klopt — zo werkt Cleven Cleaning in Den Bosch.",
    neighborhoods: [
      "Binnenstad",
      "Maaspoort",
      "Empel",
      "De Vliert",
      "Muntel",
      "Zuid & West",
    ],
    nearby: ["rosmalen", "vught", "nuland"],
  },
  {
    slug: "vught",
    name: "Vught",
    title: "Glazenwasser Vught",
    region: "Noord-Brabant",
    postcode: "5260 – 5263",
    lat: "51.6556",
    lng: "5.2876",
    intro:
      "In het groene Vught staan veel ruime villa's en karakteristieke woningen met flink wat glaswerk. Cleven Cleaning is de glazenwasser die deze panden de aandacht geeft die ze verdienen. Wij werken in Vught-Noord, Vught-Zuid en het buitengebied richting Cromvoirt, voor zowel particulieren als bedrijven.",
    body:
      "Grote raampartijen, serres en erkers reinigen wij streeploos en met oog voor detail. Dankzij onze vaste planning hoeft u nergens aan te denken: u krijgt automatisch bericht wanneer wij langskomen. Naast glasbewassing verzorgen wij in Vught ook kozijnreiniging, zonnepaneelreiniging en het onderhoud van uw dakgoten.",
    neighborhoods: ["Vught-Noord", "Vught-Zuid", "Cromvoirt", "Centrum"],
    nearby: ["den-bosch", "rosmalen", "berlicum"],
  },
  {
    slug: "berlicum",
    name: "Berlicum",
    title: "Glazenwasser Berlicum",
    region: "Noord-Brabant",
    postcode: "5258",
    lat: "51.6611",
    lng: "5.3958",
    intro:
      "Cleven Cleaning is uw glazenwasser in Berlicum en de omliggende kernen van de gemeente Sint-Michielsgestel. Wij wassen ramen voor woningen, agrarische bedrijven en lokale ondernemers, met dezelfde betrouwbare service waar wij in heel de regio om bekend staan.",
    body:
      "Of u nu in het centrum van Berlicum woont of in het landelijke buitengebied: u krijgt een vaste glazenwasser, ruim van tevoren bericht en altijd een eerlijke prijs. Naast glasbewassing kunt u bij ons terecht voor dakgoten leeghalen, kozijnreiniging en hogedrukreiniging van terras, oprit en gevel.",
    neighborhoods: ["Centrum Berlicum", "Middelrode", "Buitengebied"],
    nearby: ["rosmalen", "den-bosch", "heesch"],
  },
  {
    slug: "heesch",
    name: "Heesch",
    title: "Glazenwasser Heesch",
    region: "Noord-Brabant",
    postcode: "5384",
    lat: "51.7333",
    lng: "5.5333",
    intro:
      "In Heesch en de rest van gemeente Bernheze zorgt Cleven Cleaning voor schone ramen, frisse kozijnen en goed onderhouden gevels. Wij bedienen particuliere woningen, VvE's en bedrijven met een planning die u nooit in de steek laat.",
    body:
      "Veel woningen in Heesch hebben ruime tuinen en vrijstaande gevels — ideaal voor onze telescoopmethode waarmee wij veilig en streeploos werken, zonder ladders tegen uw huis. U ontvangt automatisch een herinnering voordat wij komen en betaalt eenvoudig achteraf per factuur.",
    neighborhoods: ["Centrum Heesch", "'t Vinkel", "Buitengebied"],
    nearby: ["nuland", "uden", "berlicum"],
  },
  {
    slug: "nuland",
    name: "Nuland",
    title: "Glazenwasser Nuland",
    region: "Noord-Brabant",
    postcode: "5391",
    lat: "51.7167",
    lng: "5.4500",
    intro:
      "Cleven Cleaning wast de ramen in Nuland en omgeving al jaren met veel plezier. Als onderdeel van de gemeente 's-Hertogenbosch ligt Nuland precies binnen ons vaste werkgebied, waardoor wij u snel en flexibel kunnen inplannen.",
    body:
      "Van rijtjeswoning tot vrijstaand huis: wij zorgen voor kristalheldere ramen, schone kozijnen en — indien gewenst — glanzende zonnepanelen voor een hoger rendement. Een vaste glazenwasser, duidelijke communicatie via ons CRM-systeem en 100% tevredenheidsgarantie. Zo houden wij uw woning het hele jaar fris.",
    neighborhoods: ["Centrum Nuland", "Vinkel", "Buitengebied"],
    nearby: ["rosmalen", "den-bosch", "heesch"],
  },
  {
    slug: "uden",
    name: "Uden",
    title: "Glazenwasser Uden",
    region: "Noord-Brabant",
    postcode: "5401 – 5406",
    lat: "51.6600",
    lng: "5.6186",
    intro:
      "Ook in Uden, gemeente Maashorst, is Cleven Cleaning uw professionele glazenwasser. Wij verzorgen de glasbewassing voor woningen, winkels en bedrijfspanden met dezelfde betrouwbare aanpak en strakke planning die onze klanten in de hele regio waarderen.",
    body:
      "U krijgt een vaste glazenwasser, ruim van tevoren bericht en streeploos resultaat dankzij onze moderne wateronthardingsinstallatie. Naast ramen wassen reinigen wij in Uden ook kozijnen, zonnepanelen en gevels, en halen wij uw dakgoten leeg om waterschade te voorkomen.",
    neighborhoods: ["Centrum Uden", "Bitswijk", "Melle", "Buitengebied"],
    nearby: ["heesch", "nuland", "rosmalen"],
  },
];

export const getLocationBySlug = (slug) =>
  locations.find((l) => l.slug === slug);
